import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { Question } from 'types/question.types';
import { EventFeedbackSettings } from 'types/questions.types';

import { QuestionInput } from '../question.types';
import { FeedbackQuestionsFragment, FeedbackSettingsFragment } from '../common';

export interface AddEventFeedbackQuestionInput {
  eventId: number;
  question: Omit<QuestionInput, 'id' | 'isDeleted'>;
}

export interface AddEventFeedbackQuestionResult {
  addEventFeedbackQuestion: {
    question: Question;
    event: EventFeedbackSettings;
  };
}

const AddEventFeedbackQuestionMutation = gql`
  mutation addEventFeedbackQuestion($input: AddEventFeedbackQuestionInput!) {
    addEventFeedbackQuestion(input: $input) {
      question {
        ...FeedbackQuestionsFragment
      }
      event {
        ...FeedbackSettingsFragment
      }
    }
  }
  ${FeedbackQuestionsFragment}
  ${FeedbackSettingsFragment}
`;

export const addEventFeedbackQuestion = (
  input: AddEventFeedbackQuestionInput
): Promise<AddEventFeedbackQuestionResult> => {
  return gqlClient.request<AddEventFeedbackQuestionResult>(AddEventFeedbackQuestionMutation, {
    input
  });
};
